import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf8.png';

const EpsStep3 = ({ previousShownErrors }) => (
  <BannerLayout
    section="FEEDBACK"
    subSection="EPS"
    previousShownErrors={previousShownErrors}
    alertText="Your net profit was not enough."
    subTitle="Return on Investments"
    paragraph1={(
      <Fragment>
        Investors monitor the earnings per share metric (EPS) very closely. A few cents
        off EPS can have a significant impact on a company's stock price. For example
        when <a href="https://www.cnbc.com/2019/08/06/disney-fiscal-q3-2019-earnings.html" rel="noreferrer" target="_blank">Disney missed their earnings</a> forecast
        by 40 cents a share, their stock price fell by 3.7%.
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        Image source: disneydining.com
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default EpsStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/eps/step3.js